import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Modal } from "@cinch-labs/design-system";
import styles from "./auth-modal-v2.module.css";
import { HeartWithRing } from "./assets/heart-with-ring";
import { AuthButtons } from "./auth-buttons";
export var AuthModalV2 = function(param) {
    var handleClose = param.handleClose, vehicleImage = param.vehicleImage, useBrowserNavigation = param.useBrowserNavigation;
    var shouldShowImage = !!vehicleImage;
    var EMPTY_TITLE = "";
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Modal, {
            classNames: {
                modal: styles.modal,
                inner: styles.modalInner
            },
            onClose: handleClose,
            ariaLabelledById: "auth-modal-title",
            heading: EMPTY_TITLE,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.contentContainer,
                children: [
                    shouldShowImage && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.iconContainer,
                                children: /*#__PURE__*/ _jsx(HeartWithRing, {})
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: vehicleImage,
                                alt: "favourited vehicle",
                                className: styles.vehicleImage
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("section", {
                        className: styles.authTitleAndText,
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                children: "Sign up to favourite cars"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: "Sync favourites across your devices and get notified of any price changes."
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(AuthButtons, {
                        useBrowserNavigation: useBrowserNavigation
                    })
                ]
            })
        })
    });
};
